import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ClassPerformanceAnalytics from "PerformanceAnalytics/routes/ClassPerformanceAnalytics";
import StudentPerformanceAnalytics from "PerformanceAnalytics/routes/StudentPerformanceAnalytics";
export default store => {
  return {
    path: ":subjectId",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "subject-overview" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [
      ClassPerformanceAnalytics(store),
      StudentPerformanceAnalytics(store),
    ],
  };
};
